import React from 'react'
import PropTypes from 'prop-types'
import { ContainedButton, OutlinedButton } from './atoms'

function Button(props) {
  const {
    variant = 'contained',
    size = 'default',
    disabled = false,
    children,
    className,
    ...rest
  } = props
  const Tag = {
    contained: ContainedButton,
    outlined: OutlinedButton,
  }[variant]
  return (
    <Tag
      {...rest}
      size={size}
      disabled={disabled}
      className={`ripple${className ? ` ${className}` : ''}`}
    >
      {children}
    </Tag>
  )
}

Button.propTypes = {
  color: PropTypes.oneOf(['default', 'primary']),
  size: PropTypes.oneOf(['default', 'medium', 'large', 'gigant']),
  variant: PropTypes.oneOf(['outlined', 'contained']),
  disabled: PropTypes.bool,
}

export default Button
